<!--
 * @FileDescription: 新增或编辑权限对话框
 * @Author: 陈文景
 * @Date: 2022-09-22 14:32:37
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <el-dialog :title="`${title}权限`" :visible.sync="visible" width="720px" :before-close="close">
    <el-form :model="form" :rules="rules" ref="form" size="medium" :label-width="`${labelWidth}px`">
      <el-form-item label="权限名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入" />
      </el-form-item>

      <el-form-item label="权限类型" prop="type">
        <el-select v-model="form.type" placeholder="请选择">
          <el-option v-for="item in permissionsType" :key="item.value" :disabled="item.disabled" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>

      <el-form-item label="上级权限" prop="parentId">
        <el-select v-model="form.parentId" filterable placeholder="请选择">
          <el-option label="一级菜单" :value="0" />
          <el-option v-for="item in superPermissions" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>

      <el-form-item label="链接地址" prop="path">
        <el-input v-model="form.path" placeholder="请输入" />
      </el-form-item>

      <el-form-item label="唯一标识" prop="slug">
        <el-input v-model="form.slug" placeholder="请输入" />
      </el-form-item>

      <el-form-item label="标识别名" prop="slugAlias">
        <el-input v-model="form.slugAlias" placeholder="请输入" />
      </el-form-item>

      <el-form-item label="菜单Icon" prop="icon">
        <el-input v-model="form.icon" placeholder="请输入" />
      </el-form-item>

      <el-form-item label="权重" prop="sort">
        <el-input-number v-model="form.sort" controls-position="right" :min="0" :max="99999" placeholder="请输入" />
      </el-form-item>

      <el-form-item label="状态" prop="status" style="margin-bottom:12px">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="2">禁用</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="展示菜单" prop="ifShow">
        <el-radio-group v-model="form.ifShow">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="2">否</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>

    <template slot="footer">
      <el-button size="medium" @click="close">取 消</el-button>
      <el-button size="medium" type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import API from '@/api'

let form = {
  parentId: 0, // 父级ID
  name: undefined, // 权限名称
  type: 1, // 1.菜单权限 2.功能权限
  path: undefined, // 菜单地址
  slug: undefined, // 权限唯一标识
  slugAlias: undefined, // 权限唯一标识别名
  icon: undefined, // 菜单Icon
  sort: 1, // 权重
  status: 1, // 1.启用 2.禁用
  id: undefined, // 新增时不传(编辑时必传)
  ifDelete: 0, // 是否删除: 0.不删除 1.删除
  ifShow: 1 // 1.是 2.否
}

export default {
  props: {
    title: {
      type: String,
      required: false,
      default: '新增'
    }
  },
  data() {
    return {
      visible: false, // 控制对话框的显示与隐藏

      labelWidth: 120, // 表单label的宽度

      superPermissions: [], // 上级权限列表

      // 权限类型列表
      permissionsType: [
        { id: 1, label: '菜单权限', value: 1, disabled: false },
        { id: 2, label: '功能权限', value: 2, disabled: true }
      ],

      form: { ...form }, // 表单对象

      // 规则数组
      rules: {
        name: [{ required: true, message: '请输入权限名称', trigger: ['change', 'blur'] }],
        type: [{ required: true, message: '请选择权限类型', trigger: ['change', 'blur'] }],
        parentId: [{ required: true, message: '请选择上级权限', trigger: ['change', 'blur'] }],
        path: [{ required: true, message: '请输入链接地址', trigger: ['change', 'blur'] }],
        sort: [{ required: true, message: '请输入权重', trigger: ['change', 'blur'] }]
      }
    }
  },
  methods: {
    /**
     * API 获取所有菜单列表
     */
    async getAllMenuPermissions() {
      let { data } = await API.getAllMenuPermissions()
      this.levelingMenus(data)
    },
    levelingMenus(menus) {
      menus.forEach((menu) => {
        if (menu.children) {
          this.levelingMenus(menu.children)
        }
        this.superPermissions.push({ id: menu.id, name: menu.name })
      })
    },

    /**
     * API 获取菜单权限详情
     * @param {Number} id 当前编辑的行信息
     */
    async getMenuPermissionsDetail(id) {
      let { data } = await API.getMenuPermissionsDetail({ id })
      this.form.parentId = data.parentId
      this.form.name = data.name
      this.form.type = data.type
      this.form.path = data.path
      this.form.slug = data.slug
      this.form.slugAlias = data.slugAlias
      this.form.icon = data.icon
      this.form.sort = data.sort
      this.form.status = data.status
      this.form.ifShow = data.ifShow
      this.form.id = data.id
    },

    /**
     * 显示对话框
     * @param {Object} payload 当前编辑的行信息
     */
    show(payload) {
      this.getAllMenuPermissions()
      // 编辑
      if (payload) {
        this.getMenuPermissionsDetail(payload.id)
      }
      this.visible = true
    },

    /**
     * 保存按钮
     */
    save() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return false
        let { code, message } = await API.addOrEditMenuPermissions(this.form)
        if (code === 10000) {
          this.close()
          this.$emit('update')
          this.$message.success(message)
        } else {
          this.$message.error(message)
        }
      })
    },

    /**
     * 关闭对话框
     */
    close() {
      this.clear()
      this.visible = false
    },

    /**
     * 负责清除数据的方法
     */
    clear() {
      this.form = { ...form }
      this.superPermissions = []
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
.el-input-number {
  width: 100%;
  /deep/.el-input__inner {
    text-align: left !important;
  }
}
</style>
